// extracted by mini-css-extract-plugin
export default {"root":"i9_lj2tfdaPaToUlp9Dq","section":"Oi7R_3mXLalKHhTD22EG"};